// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
// 引入Vant
import Vant from 'vant';
// 引入swiper样式
import 'swiper/dist/css/swiper.css';
// 引入Vant样式
import 'vant/lib/index.css';
// 引入路由
import router from './router/index'
// 引入axios
import '@/assets/js/$axios.js';
// 引入md5
import '@/assets/js/$md5.js';
// 引入font-awesome
import 'font-awesome/css/font-awesome.min.css'
// 引入Storage
import '@/assets/js/$localStorage.js';
// 引入格式化
import '@/assets/js/$moment.js';
// 引入过滤器
import '@/assets/js/$filter.js';
// 适配
import 'lib-flexible/flexible'
// 引入签名
import '@/assets/js/$sign.js';
// 引入校验文件
import '@/assets/js/check.js'
//引入调试js
import '@/assets/js/$debugger.js';
// 懒加载
import { Lazyload } from 'vant';
import VConsole from 'vconsole';
const isDebug = false;
if (isDebug) {
    new VConsole();
}
// 引用fastClick
import FastClick from 'fastclick';
FastClick.attach(document.body);
 Vue.use(Lazyload, {
  preLoad: 1.3,
  error: 'static/img/loadImg.png',
  loading: 'static/img/loadImg.png',
  attempt: 3
})
// 使用Vant
Vue.use(Vant);
// 使用路由
Vue.use(router);
Vue.config.productionTip = false

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});
import AMap from 'vue-amap';

Vue.use(AMap);

// 初始化vue-amap
AMap.initAMapApiLoader({
    // 高德key
    key: 'ec3e29785a641aaab11394a5529cb4c2',
    // 插件集合 （插件按需引入）
    plugin: [
        "AMap.Autocomplete", //输入提示插件
        "AMap.PlaceSearch", //POI搜索插件
        "AMap.Scale", //右下角缩略图插件 比例尺
        "AMap.OverView", //地图鹰眼插件
        "AMap.ToolBar", //地图工具条
        "AMap.MapType", //类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
        "AMap.PolyEditor", //编辑 折线多，边形
        "AMap.CircleEditor", //圆形编辑器插件
        "AMap.Geolocation" //定位控件，用来获取和展示用户主机所在的经纬度位置
    ],
});

new Vue({
    el: '#app',
    router,
    components: {App},
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js